import React, { useRef } from 'react';
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import { useSelector } from 'react-redux';
import {
  Card,
  CardContent,
  Input,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox
} from "@material-ui/core";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import ReactToPrint from 'react-to-print';
import { MdPrint } from "react-icons/md";
import moment from 'moment';

const cellStyle = {
  center: {
    borderRight: '1px solid #ddd',
    borderBottom: '1px solid #ddd',
    padding: '6px',
    textAlign: 'center'
  },
  left: {
    borderRight: '1px solid #ddd',
    borderBottom: '1px solid #ddd',
    padding: '6px',
    textAlign: 'left'
  },
  remarks: {
    borderBottom: '1px solid #ddd',
    padding: '6px'
  }
};

const checklistPoints = [
  "Cover Page With All Details Are Filled And Correct",
  "Floor Plan With Furniture Layout With Scope Of Work Present And Correct",
  "Laminate Tabular Sheet Is Present And Correct As Per MOM's",
  "Hatching Details Matching With 2D And 3D",
  "Check For Vertical And Horizontal Dimensions Individual And Overall (Including Filler, Skirting, Cover Panel) (Not Required To Check As Per Site QC)",
  "Handle Details Are Mentioned",
  "Tape Masking - Site Image Attached",
  "Non-Standard Laminate/Acrylic/Hardware/Accessories If Any Approval Received",
  "Line Items In The Quotation To Be Reflected In The 2D Along With The Materials/Finishes",
  "2D And Quotation To Be Segregated Areawise",
  "Hardware/Accessories Used Are As Per Standards Only",
  "Jaali Used Are As Per Standards",
  "SC And SH To Be Segregated Areawise In The Quotation"
];

const AdmCheckList = (props) => {
  const checklistRef = useRef();
  const { userDetails } = useSelector(state => state.user);

  const isReadOnly = true;

  const handleRemarksChange = (index, value) => {
    if (isReadOnly) return;
    // logic for updating remarks if needed
  };

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', padding: "20px", backgroundColor: '#f8f9fa' }}>
      <div
        ref={checklistRef}
        style={{
          margin: 'auto',
          backgroundColor: 'white',
          border: "1px solid #ddd",
          borderRadius: "10px",
          padding: "30px",
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <img
            src="https://www.decorpot.com/images/decorpot-home-interior-designers-logo.png"
            alt="Decorpot Logo"
            style={{ maxWidth: "200px", height: "auto" }}
          />
          <ReactToPrint
            trigger={() => (
              <MdPrint
                size={28}
                style={{ cursor: 'pointer', color: '#F47E46' }}
                title="Print"
              />
            )}
            content={() => checklistRef.current}
          />
        </div>

        <div
          style={{
            textAlign: 'center',
            backgroundColor: '#F47E46',
            color: 'white',
            border: '2px solid #F47E46',
            borderRadius: '8px',
            margin: '20px 0'
          }}
        >
          <h1 style={{ fontSize: "26px", fontWeight: "bold", margin: 0 }}>ADM CHECKLIST</h1>
        </div>

        <Card style={{ marginBottom: 20 }}>
          <CardContent>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>

              <div style={{ flex: '1 1 45%' }}>
                <div style={{ fontWeight: "600", marginBottom: 5 }}>Project No</div>
                <Input
                  fullWidth
                  disableUnderline
                  value={props.projectDetails?.erpProjectNo || ''}
                  disabled
                  style={{
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    padding: '0',
                    boxSizing: 'border-box',
                    color: "black",
                  }}
                />
              </div>

              <div style={{ flex: '1 1 45%' }}>
                <div style={{ fontWeight: "600", marginBottom: 5 }}>Client Name</div>
                <Input
                  fullWidth
                  disableUnderline
                  value={props.projectDetails?.customerId?.name || ''}
                  disabled
                  style={{
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    padding: '0',
                    boxSizing: 'border-box',
                    color: "black",
                  }}
                />
              </div>

              <div style={{ flex: '1 1 45%' }}>
                <div style={{ fontWeight: "600", marginBottom: 5 }}>Designer</div>
                <Input
                  fullWidth
                  disableUnderline
                  value={props.projectDetails?.raisedQCDesignerName || ''}
                  disabled
                  style={{
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    padding: '0',
                    boxSizing: 'border-box',
                    color: "black",
                  }}
                />
              </div>

              <div style={{ flex: '1 1 45%' }}>
                <div style={{ fontWeight: "600", marginBottom: 5 }}>Date</div>
                <Input
                  fullWidth
                  disableUnderline
                  value={props.projectDetails?.admCheckListDate 
                    ? moment(props.projectDetails?.admCheckListDate ).format('DD-MM-YYYY') 
                    : ''}
                  disabled
                  style={{
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    padding: '0',
                    boxSizing: 'border-box',
                    color: "black",
                  }}
                />
              </div>

            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent style={{ padding: 0 }}>
            <div style={{ overflowX: 'auto' }}>
              <Table style={{ minWidth: '100%', borderCollapse: 'collapse' }}>
                <TableHead>
                  <TableRow style={{ backgroundColor: '#f1f1f1' }}>
                    <TableCell style={{ fontWeight: 'bold', width: '5%', textAlign: 'center', borderRight: '1px solid #ddd' }}>SL NO</TableCell>
                    <TableCell style={{ fontWeight: 'bold', width: '50%', textAlign: 'center', borderRight: '1px solid #ddd' }}>POINTS TO BE CHECKED</TableCell>
                    <TableCell style={{ fontWeight: 'bold', width: '5%', textAlign: 'center', borderRight: '1px solid #ddd' }}>STATUS</TableCell>
                    <TableCell style={{ fontWeight: 'bold', textAlign: 'center', width: '40%' }}>REMARKS</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {checklistPoints.map((point, index) => {
                    const item = props.projectDetails?.aDMChecklist?.[index] || {};
                    return (
                      <TableRow key={index}>
                        <TableCell style={cellStyle.center}>{index + 1}</TableCell>
                        <TableCell style={cellStyle.left}>{point}</TableCell>
                        <TableCell style={cellStyle.center}>
                          <Checkbox
                            style={{
                              backgroundColor: isReadOnly ? 'transparent' : 'transparent',
                              color: 'green',
                            }}
                            checked={item.checkbox || false}
                            disabled={isReadOnly}
                          />
                        </TableCell>
                        <TableCell style={cellStyle.remarks}>
                          <TextareaAutosize
                            minRows={2}
                            placeholder="Remarks"
                            value={item.remarks || 'N/A'}
                            onChange={(e) => handleRemarksChange(index, e.target.value)}
                            disabled={isReadOnly || !item.checkbox}
                            style={{
                              width: '100%',
                              padding: '6px',
                              border: '1px solid #ccc',
                              borderRadius: '4px',
                              fontSize: '13px',
                              resize: 'vertical',
                              boxSizing: 'border-box',
                              backgroundColor: isReadOnly ? 'transparent' : 'transparent',
                              color: 'black',
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>

        <div style={{ flex: '1 1 45%', display: 'flex', alignItems: 'center', marginBottom: '10px', marginTop: "10px" }}>
          <div style={{ fontWeight: 600, marginRight: '10px', whiteSpace: 'nowrap', width: '120px' }}>
            Design Manager
          </div>
          <Input
            fullWidth
            disableUnderline
            value={props.projectDetails?.checkListDesignerSignatureName || ''}
            disabled={isReadOnly}
            style={{
              border: '1px solid #ccc',
              borderRadius: '4px',
              padding: '4px 8px',
              boxSizing: 'border-box',
              color: 'black',
              flex: 1,
              marginLeft: '20px',
            }}
          />
        </div>

        <p style={{
          fontSize: '12px',
          color: '#888',
          fontStyle: 'italic',
          marginTop: '20px',
          textAlign: 'center'
        }}>
          Note: Document Shared On Or Before 7 PM Of The Previous Day Will Be Considered For Current Day Slot
        </p>
      </div>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(AdmCheckList);
